var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(41 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13017",
    "data-name": "Path 13017",
    d: "M13.292,12.584H1.416V10.847l5.57-5.22L8.864,7.505a.707.707,0,0,0,1,0l3.54-3.54a.708.708,0,1,0-1-1L9.365,6l-1.86-1.86a.707.707,0,0,0-.982-.019L1.416,8.912V.708A.713.713,0,0,0,.708,0,.713.713,0,0,0,0,.708V13.292A.713.713,0,0,0,.708,14H13.292a.708.708,0,0,0,0-1.416Z",
    transform: "translate(-41 -4)",
    fill: "#868a97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesGraph);
export default __webpack_public_path__ + "static/media/salesGraph.57a3c139b695d2a7ba72349f9b8a1b3c.svg";
export { ForwardRef as ReactComponent };